"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureYourFutureToday() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="857" id="secure-your-future-today" className="dark bg-background text-foreground relative overflow-hidden" style={{
    paddingTop: "7rem",
    paddingBottom: "7rem"
  }}>
      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-md opacity-[0.08] blur-3xl" style={{
      background: "radial-gradient(circle, var(--primary) 0%, var(--chart-5) 40%, transparent 70%)"
    }} aria-hidden="true" />

      <div ref={ref} className={`relative mx-auto px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
      maxWidth: "900px"
    }}>
        {}
        <div className="mb-8 flex justify-center items-center gap-3">
          
          <span className="font-mono text-xs tracking-[0.2em] uppercase" style={{
          color: "var(--primary)"
        }}><br /></span>
        </div>

        {}
        <h2 className="font-default font-semibold leading-[1.05] tracking-tight mb-8" style={{
        fontSize: "clamp(3rem, 6vw, 5rem)",
        color: "var(--foreground)"
      }}>
          Secure your{" "}
          <em className="italic font-serif font-normal" style={{
          color: "var(--primary)"
        }}>
            family legacy.
          </em>
        </h2>

        {}
        <p className="font-default text-lg md:text-xl mb-12 mx-auto leading-relaxed" style={{
        color: "var(--muted-foreground)",
        maxWidth: "640px"
      }}>
          A comprehensive Legacy Review identifies vulnerabilities in your current estate plan. Protect what you&apos;ve built for the next generation.
        </p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-10">
          <Link to="/ContactPage">
            
          </Link>

          
        </div>

        {}
        <div className="font-mono text-xs tracking-[0.18em] uppercase flex flex-wrap items-center justify-center gap-x-3 gap-y-2" style={{
        color: "var(--muted-foreground)"
      }}>
          <span>Wealth Preservation</span>
          <span aria-hidden="true" style={{
          color: "var(--primary)"
        }}>·</span>
          <span>Asset Protection</span>
          <span aria-hidden="true" style={{
          color: "var(--primary)"
        }}>·</span>
          <span>Florida Estate Law</span>
        </div>
      </div>
    </section>;
}